import React from 'react';

function Resume() {


        return (
            <React.Fragment>
                <section id="resume">
                {/* Education
                ----------------------------------------------- */}
                <div className="row education">
                    <div className="three columns header-col">
                    <h1><span>Education</span></h1>
                    </div>
                    <div className="nine columns main-col">
                    <div className="row item">
                        <div className="twelve columns">
                        <h3>Austin Community College</h3>
                        <p className="info">Computer Aided Drafting <span>•</span> <em className="date">April 2014</em></p>
                        <p>
                            Member of the President's Honor Roll, National Society of Collegiate Scholars and Php Theta Kappa International Honor Society.
                        </p>
                        </div>
                    </div> {/* item end */}
                    </div> {/* main-col end */}
                </div> {/* End Education */}
                {/* Work
                ----------------------------------------------- */}
                <div className="row work">
                    <div className="three columns header-col">
                    <h1><span>Work</span></h1>
                    </div>
                    <div className="nine columns main-col">
                    <div className="row item">
                        <div className="twelve columns">
                        <h3>Johnson Sewell Lincoln Ford</h3>
                        <p className="info">Sales Porter <span>•</span> <em className="date">July 2018 - March 2020</em></p>
                        <ul>
                            <li>
                                Check in new vehicles from Transport to PDI (Pre-Delivery Inspection). This involved checking vehicles for damage during
transport, matching items to the loose item checklist, and transporting the keys to accounting for inventory.
                            </li>
                            <li>
                                Picturing and fueling new vehicles for lot. This involved taking pictures of the new vehicles for web publication, using a company
issued credit card for filling up the vehicles.
                            </li>
                            <li>
                                Managed lot. Parked new and used vehicles in a neat and orderly fashion according to their grouping in the parking lot.
                            </li>
                            <li>
                                Physical inventory. Perform monthly physical inventory reconciling vehicles on report to vehicles on the lot, based on VIN (Vehicle
Identification Number) to report generated by Sales VP. Investigated and reconciled missing vehicles with Sales VP.
                            </li>
                            <li>
                                Developed Excel spreadsheets for PDI and Physical Inventory.
                            </li>
                            <li>
                                Detailed job duties and documented processes. I worked with HR to create multiple checklists for Sales Porter duties
                            </li>
                        </ul>
                        </div>
                    </div> {/* item end */}
                    <div className="row item">
                        <div className="twelve columns">
                        <h3>Amazon</h3>
                        <p className="info">Seasonal Conversion Part-Time Sorter/Runner <span>•</span> <em className="date">February 2018 - July 2018</em></p>
                        <ul>
                            <li>
                                Work midnight to 6:30 a.m. shift at Amazon’s DAU1 warehouse in order to sort packages for Amazon Prime Next Day operations
                            </li>
                            <li>
                                Sort 250+ packages per hour in to tote bags for morning shift
                            </li>
                            <li>
                                Distribute packages up to 50 lbs. for sortation employees
                            </li>
                            <li>
                                Train new sortation employees on proper logging, scanning, and sorting techniques to achieve highest yield
                            </li>
                        </ul>
                        </div>
                    </div> {/* item end */}
                    <div className="row item">
                        <div className="twelve columns">
                        <h3>D&B</h3>
                        <p className="info">Computer Telephone Integration Technology Expert <span>•</span> <em className="date">May 2001 - December 2006</em></p>
                        <ul>
                            <li>
                                Worked with Directors to define web application specifications.
                            </li>
                            <li>
                                Created ASP.Net application responsible for tracking of issues between IBM India and Dun & Bradstreet North America; defining
security roles, email functionality, allowing upload of various file types for viewing and ad-hoc reporting capabilities.
                            </li>
                            <li>
                                Created ASP forms for Agents to gather survey information that will be used later to create intelligent marketing lists for a higher
rate of return.
                            </li>
                            <li>
                                Created and modified web pages using ASP technology to save information to MSSQL databases for processing and reporting.
                            </li>
                            <li>
                                Worked with third party ActiveX controls to build web sites consisting of ASP pages that extrapolated DNB data and stored specific
information and reports to Microsoft SQL 2000 database utilizing CDONTS to email results to management.
                            </li>
                            <li>
                                Developed MSSQL queries utilized by ASP pages for statistical reporting.
                            </li>
                            <li>
                                Developed databases and maintenance plans for each database; created tables, views and queries to insert, update and read
information from multiple servers.
                            </li>
                            <li>
                                Provided secondary support for desktop systems and mainframe applications utilized by desktop systems.
                            </li>
                            <li>
                                Supported, maintained and manipulated Genesys application suite, which provides intelligent, media independent routing to Dun &
Bradstreet Customer Service, Sales and Technical Support departments.
                            </li>
                            <li>
                                Created Genesys strategies which processed information collected from Intervoice-Brite IVR and checked data against various
conditions within the strategy and routed call accordingly.
                            </li>
                            <li>
                                Programmed and modified options within Intervoice-Brite IVR.
                            </li>
                            <li>
                                Developed MSSQL queries utilized by Intervoice-Brite IVR and Genesys to pass customer information to Customer Service, Sales
and Technical Support.
                            </li>
                            <li>
                                Worked with Computer Systems Management Engineer in support of PBX system and ACD switch; providing ACD log-ins,
managed ACD groups, created and maintained internal DNITs and ARTS.
                            </li>
                        </ul>
                        </div>
                    </div> {/* item end */}
                    <div className="row item">
                        <div className="twelve columns">
                        <h3>D&B</h3>
                        <p className="info">Senior Advanced Technical Support Representative <span>•</span> <em className="date">January 1997 - May 2001</em></p>
                        <ul>
                            <li>
                                Winner of 1999 Leadership Award.
                            </li>
                            <li>
                                Team Lead of Risk Assessment Manager in charge of testing, approving and submitting reports regarding status of releases to
Management for Monthly Status Report.
                            </li>
                            <li>
                                Internal Technical Support for the Austin Customer Resource Center: duties included setting up SAPS modem pool, fax pool and
print servers.
                            </li>
                            <li>
                                Designed and set-up Technical Support software testing lab including machines running Windows 95, Windows 98, Windows NT
4.0 Workstation and Server, Windows ME, Windows 2000 Professional and Novell 5 along with images of the hard drives to bring
the machines back to specification after completion of software testing.
                            </li>
                            <li>
                                Installation of software development server running Internet Information Server 4.0 with Windows NT Server and MSSQL 2000
running as the backbone for local database / intranet development on company intranet site.
                            </li>
                            <li>
                                Troubleshoot customer TCP/IP connectivity issues between Dun & Bradstreet software and various firewall/proxy servers for
mainframe connectivity.
                            </li>
                            <li>
                                Developed and produced Usage Adjustment web site as a way for Core Team representatives to have their usage requests completed
in a more expeditious manner.
                            </li>
                            <li>
                                Developed and co-produced Risk Assessment Manager Fulfillment form on the Dun & Bradstreet intranet used for ordering, reordering and tracking software submittals, from both internal and external (Airborne Express, Federal Express) sources.
                            </li>
                            <li>
                                Produced web pages for company intranet detailing steps to take with customers on converting ASCII files and importing said files
into third party software.
                            </li>
                            <li>
                                Performed demonstrations to customers on how to convert ASCII files into delimiters for best results in their third party software.
                            </li>
                            <li>
                                Installation and support for SQL based applications on both Windows NT Server 3.51/4.0 and Novell 3.12/4.11 Servers.
                            </li>
                            <li>
                                Wrote specific Sybase and MSSQL scripts to solve database issues that had not been addressed by software developers.
                            </li>
                            <li>
                                Answered communications issues regarding difficulties between V.90 and V.34 modems and find strings to communicate between
the two.
                            </li>
                            <li>
                                Created and modified customized reports based on Dun & Bradstreet Risk Assessment Management information for the Crystal
Reports front-end viewer
                            </li>
                           </ul>
                        </div>
                    </div> {/* item end */}
                    </div> {/* main-col end */}
                </div> {/* End Work */}
                {/* Skills
                ----------------------------------------------- */}
                <div className="row skill">
                    <div className="three columns header-col">
                    <h1><span>Skills</span></h1>
                    </div>
                    <div className="nine columns main-col">
                    <p>
                        Throughout the bootcamp we were introduced to the following languages.  Some, such as javascript, HTML5 and CSS, I have had experience with when working at D&B.
                    </p>
                    <div className="bars">
                        <ul className="skills">
                        <li><span className="bar-expand javascript" /><em>JavaScript</em></li>
                        <li><span className="bar-expand HTML5" /><em>HTML5</em></li>
                        <li><span className="bar-expand github" /><em>GitHub</em></li>
                        <li><span className="bar-expand express" /><em>Express</em></li>
                        <li><span className="bar-expand css" /><em>CSS</em></li>
                        <li><span className="bar-expand handlebars" /><em>Handlebars</em></li>
                        <li><span className="bar-expand react" /><em>React</em></li>
                        </ul>
                    </div>{/* end skill-bars */}
                    </div> {/* main-col end */}
                </div> {/* End skills */}
                </section> {/* Resume Section End*/}

            </React.Fragment>
        )
    
}

export default Resume;